module.exports = __webpack_public_path__ + "static/img/bg.b2764bbb.jpg";